import { ILayoutToolsAction } from '@base/@types/components/Layout/Tools'
import { IActionsHeaderKpi } from '@base/@types/providers/Kpi/LogisticProvider'

export const actionsHeaderKpi = ({
  data,
  headers,
  toggleColumn,
  parseLogisticKpiData
}: IActionsHeaderKpi) => {
  return [
    {
      type: 'export',
      exports: [
        {
          type: 'excel',
          entity: 'logisticKpi',
          data,
          headers,
          parser: parseLogisticKpiData
        }
      ]
    },
    {
      type: 'columns',
      data: headers,
      onToggleColumn: toggleColumn
    }
  ] as ILayoutToolsAction[]
}
